(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter);
    global.useLocationKey = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getLocationKey = getLocationKey;
  _exports.getLocationKeys = getLocationKeys;
  _exports.useLocationKey = useLocationKey;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function getLocationKey(location) {
    var _location$state;

    var routerIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if ((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.__key && location.state.__key.length >= routerIndex + 1) {
      return location.state.__key[routerIndex];
    } else {
      return location.key;
    }
  }

  function getLocationKeys(location, routerIndex) {
    var _location$state2, _location$state3;

    var cutLastKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var locationKeys = (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.__key;

    if (locationKeys && locationKeys.length >= routerIndex + 1) {
      locationKeys = _toConsumableArray(locationKeys).splice(0, routerIndex + 1);
    } else if ((_location$state3 = location.state) !== null && _location$state3 !== void 0 && _location$state3.__key) {
      locationKeys = [].concat(_toConsumableArray(locationKeys), [location.key]);
    } else {
      locationKeys = [location.key];
    }

    if (routerIndex && locationKeys.length < routerIndex + 1) {
      var prepend = Array(routerIndex + 1 - locationKeys.length).fill(location.key);
      return prepend.concat(locationKeys);
    }

    return locationKeys;
  }

  function useLocationKey() {
    var _useContext = (0, _react.useContext)(_reactRouter.__RouterContext),
        routerIndex = _useContext.routerIndex;

    var location = (0, _reactRouter.useLocation)();
    return (0, _react.useMemo)(function () {
      return getLocationKey(location, routerIndex);
    }, [location, routerIndex]);
  }
});